// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles__overlay--2fdi5"};
    if(module.hot) {
      // 1541451118385
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  